import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'app-custom-toast',
  template: `
    <div class="custom-toast">
      <div class="custom-toast-header">
        <strong>{{ title }}</strong>
      </div>
      <div class="custom-toast-body">
        {{ message }}
      </div>
    </div>
  `,
  standalone: true,
})
export class ToastComponent extends Toast {}
